import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkPlus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bookmark-plus, banner, flag, tag"><path d="M19.25 21V2.75H4.75V21L12 17L19.25 21Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 6.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 10L8.75 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBookmarkPlus;
